import { useMemo } from "react";
import { useSelector } from "react-redux";
import { RootState } from "../store/store";
import { HealthcareFacilityStats } from "../types/facility.definition";

function useFacilityStats(): {
  stats: HealthcareFacilityStats | undefined;
  loading: boolean;
  error: string | null;
} {
  const { stats, loading, error } = useSelector(
    (state: RootState) => state.dashboard
  );

  return useMemo(() => {
    return {
      stats,
      loading,
      error,
    };
  }, [stats, loading, error]);
}

export default useFacilityStats;
